import { render, staticRenderFns } from "./StepsOptionsTorso.vue?vue&type=template&id=3b6f86b9"
import script from "./StepsOptionsTorso.vue?vue&type=script&lang=js"
export * from "./StepsOptionsTorso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports